import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgArrowButtonRight1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M13.584 12a2.64 2.64 0 0 1-.775 1.875l-9.541 9.541a1.768 1.768 0 0 1-2.5-2.5l8.739-8.739a.25.25 0 0 0 0-.354L.768 3.084a1.768 1.768 0 0 1 2.5-2.5l9.541 9.541A2.64 2.64 0 0 1 13.584 12"
      fill="currentColor"
    />
    <path
      d="M23.75 12a2.64 2.64 0 0 1-.775 1.875l-9.541 9.541a1.768 1.768 0 0 1-2.5-2.5l8.739-8.739a.25.25 0 0 0 0-.354l-8.739-8.739a1.768 1.768 0 0 1 2.5-2.5l9.541 9.541A2.64 2.64 0 0 1 23.75 12"
      fill="currentColor"
    />
  </svg>
);
